<template src="./template.html" ></template>

<script>
// @ is an alias to /src
// import {
//   showSnackbar
// } from "../../components/MySnackbar/globalActions";
import MyPrintMelli from './PrintMelli.vue'
import MyBoxes from '../../components/MyBoxes.vue'
import MyBankaccounts from '../../components/MyBankaccounts.vue'
import MyDate from '../../components/MyDate.vue'
import myAxios from '../../functions/myAxios'
import MyListTable from './Table.vue'
import MyButtons from './Buttons.vue'
import MyActionButtons from './ActionButtons.vue'
import MyViewButtons from './viewButtons.vue'
import {
  toJalaali,
  isValidJalaaliDate
} from '../../functions/myDate'
let cloneData = []
//
export default {
  name: 'ChequeView',
  methods: {
    getRequestParams(searchText, searchItem, tableView, page, pageCount) {
      let params = {}

      if (searchItem) {
        params["searchItem"] = searchItem
      }

      if (searchText) {
        params["searchText"] = searchText
        this.tableView = 'all'
        tableView = 'all'
      }

      if (tableView) {
        params["tableView"] = tableView
      }

      if (page) {
        params["page"] = page - 1
      }

      if (pageCount) {
        params["size"] = pageCount
      }

      return params
    },
    async retrieveData() {
      const query = this.getRequestParams(
        this.searchText,
        this.searchItem.name,
        this.tableView,
        this.page,
        this.pageCount
      );
      this.loading = true
      try {
        // console.log(query);
        //
        let res = await myAxios({
          method: 'GET',
          url: `/api/${this.route}`,
          params: query
        });
        // console.log(res.data.data);
        if (res && res.data && res.data.data && res.data.page) {
          this.data = res.data.data
          cloneData = res.data.data
          // this.totalPages = Math.ceil(Number(res.data.count) / this.pageCount)
          // if (this.page != res.data.page) {
          //   this.page = res.data.page
          // }
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    setDatePh(item) {
      this.ph_date = item
    },
    setDateDv(item) {
      this.dv_date = item
    },
    handleChangeSelectItem() {
      if (this.searchItem.name === 'date') {
        // this.searchText = '1401/12/27'
        this.searchText = toJalaali(new Date()).date
      } else {
        this.searchText = ''
      }
      this.page = 1
      this.debounceSearch()
    },
    handlePageChange(value) {
      if (Number(this.$router.currentRoute.params.PageNum) !== Number(value)) {
        let url = `/${this.route}/page/${value}`
        this.$router.push({
          path: url
        }) // -> /banks/page/123
        this.retrieveData()
      }
    },
    handlePageCountChange(size) {
      this.pageCount = size;
      this.page = 1;
      this.retrieveData();
    },
    debounceSearch() {
      clearTimeout(this.debounce)
      //
      this.debounce = setTimeout(() => {
        if (this.searchItem.name === 'date') {
          if (!isValidJalaaliDate(this.searchText)) {
            return;
          }
        }
        if (this.formStatus === 'view') {
          this.page = 1
          this.retrieveData()
        } else {
          if (this.searchText) {
            let result = cloneData.filter(el => String(el[this.searchItem.name]).toLowerCase().includes(this.searchText));
            this.data = result
          } else {
            this.data = cloneData
          }
        }
      }, 1000)
    },
    setFormStatus(newStatus) {
      if (this.formStatus === 'view') {
        this.searchText = ''
        this.formStatus = newStatus
        this.showSelect = true
        if (newStatus === 'pn' || newStatus === 'dv') {
          this.singleSelect = false
          this.setTableView('available')
        } else if (newStatus === 'odat') {
          this.singleSelect = true
          this.setTableView('available')
        } else if (newStatus === 'ph' || newStatus === 'out' || newStatus === 'bg') {
          this.singleSelect = false
          this.setTableView('dv')
        } else if (newStatus === 'undo') {
          this.singleSelect = true
          this.setTableView('undo')
        }
      } else {
        this.setNewStatus()
      }
    },
    async setNewStatus() {
      let _data = {}
      if (this.selected.length) {
        if (this.formStatus === 'pn') {
          if (this.box_id) {
            if (window.confirm(`آیا مایل به پاس نقدی چک های انتخابی هستید؟`) === true) {
              _data.cheques = this.selected
              _data.box_id = this.box_id
              _data.newStatus = this.formStatus
            } else {
              return;
            }
          } else {
            alert('صندوق را انتخاب کنید')
            return;
          }
        }
        if (this.formStatus === 'dv') {
          if (this.bank_account_id) {
            if (window.confirm(`آیا مایل به واگذاری چک های انتخابی به حساب هستید؟`) === true) {
              _data.cheques = this.selected
              _data.bank_account_id = this.bank_account_id
              _data.newStatus = this.formStatus
            } else {
              return;
            }
          } else {
            alert('حساب بانکی را انتخاب کنید')
            return;
          }
        }
        if (this.formStatus === 'ph') {
          if (window.confirm(`آیا مایل به پاس چک های انتخابی به حساب هستید؟`) === true) {
            _data.cheques = this.selected
            _data.ph_date = this.ph_date
            _data.newStatus = this.formStatus
          } else {
            return;
          }
        }
        if (this.formStatus === 'out') {
          if (window.confirm(`آیا مایل به خارج کردن چک های انتخابی از حساب هستید؟`) === true) {
            _data.cheques = this.selected
            _data.newStatus = this.formStatus
          } else {
            return;
          }
        }
        if (this.formStatus === 'bg') {
          if (window.confirm(`آیا مایل به برگشت زدن چک های انتخابی هستید؟`) === true) {
            _data.cheques = this.selected
            _data.newStatus = this.formStatus
          } else {
            return;
          }
        }
        if (this.formStatus === 'odat') {
          if (window.confirm(`آیا مایل به عودت چک انتخابی هستید؟`) === true) {
            _data.cheques = this.selected
            _data.newStatus = this.formStatus
            _data.serial = this.selected[0].serial
            _data.person_id = this.selected[0].person_id[0]
          } else {
            return;
          }
        }
        if (this.formStatus === 'undo') {
          if (window.confirm(`آیا مایل به بازگشت به وضعیت قبلی چک انتخابی هستید؟`) === true) {
            _data.cheques = this.selected
            _data.newStatus = this.formStatus
          } else {
            return;
          }
        }
      } else {
        return
      }
      try {
        _data = {
          method: 'post',
          url: `/api/${this.route}/setStatus`,
          data: _data
        }
        await this.$store.dispatch('save', _data)
        let res = this.$store.getters.saveData
        if (res.update) {
          this.showSelect = false
          this.selected = []
          if (this.formStatus === 'out' || this.formStatus === 'undo') {
            this.tableView = 'available'
          } else {
            this.tableView = this.formStatus
          }
          this.formStatus = 'view'
          this.retrieveData()
        }
        // console.log(res);
      } catch (e) {
        console.log(e);
      }
    },
    setTableView(type) {
      this.tableView = type
      this.retrieveData()
    },
    getTableSelected(rows) {
      this.selected = rows.map((r) => {
        let item = {
          _id: r._id,
          person_id: r.person_id,
          serial: r.serial,
          price: r.price,
          //for print
          date: r.date,
          number: r.number,
          bank: r.bank[0],
          branch: r.branch,
        }
        if (r.status) item.currentStatus = r.status
        if (r.bg_date) item.bg_date = r.bg_date
        return item
      })
      // console.log(this.selected);
    },
    async printDoc() {
      if (!this.selected.length) return
      //
      this.showPrintTable = true
      // Get HTML to print from element
      const prtHtml = document.getElementById('print').innerHTML
      // Get all stylesheets HTML
      let stylesHtml = '';
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      const WinPrint = window.open();
      // <p style="text-align: center">صورت حساب</p>
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            ${stylesHtml}
          </head>
          <body>
            <br/>
            <div style="margin: 20px">
            ${prtHtml}
            </div>
            <br/>
          </body>
        </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      setTimeout(() => {
        WinPrint.print();
        WinPrint.close();
      }, 500)
      // this.print = true
      // setTimeout(() => {
      //   window.print()
      // }, 100)
      this.showPrintTable = false
    },
    async getBankaccount() {
      try {
        let res = await myAxios({
          method: 'GET',
          url: `/api/bank_accounts/name`,
          // params: query
        });
        // console.log(res.data);
        if (res && res.data) {
          let bank = res.data.filter(x => x._id === this.bank_account_id)
          if (bank && bank.length) {
            this.bank_account = bank[0]
          } else {
            this.bank_account = null
          }
        }
        return null
      } catch (e) {
        console.log(e);
      }
    },
    back() {
      this.searchText = ''
      this.tableView = 'available'
      this.formStatus = 'view'
      this.showSelect = false
      this.selected = []
      this.retrieveData()
    },
  },
  async created() {
    this.route = this.$store.getters.pageInfo.route
    this.formTitle = this.$store.getters.pageInfo.formTitle
    this.headers = this.$store.getters.pageInfo.headers
    this.searchItems = this.$store.getters.pageInfo.searchItems
    if (this.searchItems.length) {
      this.searchItem = this.searchItems[0]
    }
    //
    let page = this.$router.currentRoute.path.split("/")[3]
    // alert(page);
    this.page = Number(page)
  },
  async mounted() {
    if (this.$refs.search) {
      this.$refs.search.focus()
    }
    this.retrieveData()
  },
  data: () => ({
    loading: false,
    formStatus: 'view', //view or pn,dv,ph,out,bg,odat,undo
    tableView: 'available', //available,pn,dv,ph,bg,odat,init,all
    data: [],
    box_id: null,
    bank_account_id: null,
    bank_account: null,
    ph_date: toJalaali(new Date()).date,
    //print doc
    showPrintTable: false,
    dv_date: toJalaali(new Date()).date,
    //table
    singleSelect: false,
    showSelect: false,
    selected: [],
    // expanded: [],
    //
    searchItem: [],
    searchText: "",
    page: 0,
    totalPages: 0,
    pageCount: 10,
    itemsPerPage: [10, 25, 50],
  }),
  components: {
    MyListTable,
    MyButtons,
    MyDate,
    MyViewButtons,
    MyActionButtons,
    MyBoxes,
    MyBankaccounts,
    MyPrintMelli,
  },
}
</script>

<style lang="scss">
</style>
